import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import FilterSubItem from './FilterItem';

// queryString.parse splits on every &, breaking values like "Baker & Baker".
// This parser only splits on & that precede a key= pattern.
const parseFilterQuery = query => {
  if (!query) return {};
  const str = query.replace(/^\?/, '');
  const parts = str.split(/&(?=[^&=]+=)/);
  return parts.reduce((acc, part) => {
    const eqIdx = part.indexOf('=');
    if (eqIdx === -1) return acc;
    const key = decodeURIComponent(part.slice(0, eqIdx));
    const val = decodeURIComponent(part.slice(eqIdx + 1));
    acc[key] = val;
    return acc;
  }, {});
};
import {
  StyledFilterItem,
  CheckBox,
  Number,
  StyledItem,
  ItemLabel,
  ItemArrowUp,
} from './Filter.style';

export default class FilterItem extends PureComponent {
  static propTypes = {
    item: PropTypes.object.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    isRoot: PropTypes.bool,
    parentIndex: PropTypes.string,
  };

  static hasSelectedSub(item) {
    return !!(item.counts && item.counts.some(sub => sub.selected));
  }

  state = {
    checked: !!this.props.isChecked,
    expanded: FilterItem.hasSelectedSub(this.props.item),
    activeSubQuery: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isChecked !== this.props.isChecked) {
      this.setState({checked: !!this.props.isChecked});
    }
    if (prevProps.item !== this.props.item) {
      this.setState(s => ({
        activeSubQuery: null,
        expanded: s.expanded || FilterItem.hasSelectedSub(this.props.item),
      }));
    }
  }

  onItemChange = () => {
    const {
      item,
      onCheckboxChange,
      parentQuery,
      isCategorySearch,
      isRoot,
    } = this.props;
    // only apply `parentQuery` on the category search result
    const unQuery =
      isCategorySearch && !isRoot ? parentQuery || item.unquery : item.unquery;
    const query = this.state.checked ? unQuery : item.query;
    const updatedParams = parseFilterQuery(query);
    onCheckboxChange(updatedParams);
    const hasSubItems = !!(item.counts && item.counts.length > 0);
    this.setState(s => ({
      checked: !s.checked,
      expanded: hasSubItems ? true : s.expanded,
    }));
  };

  onSubItemChange = (params, subQuery) => {
    const {onCheckboxChange} = this.props;
    this.setState({
      checked: false,
      activeSubQuery: subQuery,
    });
    onCheckboxChange(params);
  };

  render() {
    const {item, parentIndex, isCategorySearch} = this.props;
    const {checked, expanded, activeSubQuery} = this.state;

    const hasSubItems = !!(item.counts && item.counts.length > 0);
    const id = parentIndex + item.id;

    const renderSubItems =
      hasSubItems &&
      expanded &&
      item.counts.map(subItem => (
        <FilterSubItem
          key={subItem.query}
          item={subItem}
          onCheckboxChange={params =>
            this.onSubItemChange(params, subItem.query)
          }
          isChecked={
            activeSubQuery !== null
              ? subItem.query === activeSubQuery
              : subItem.selected
          }
          parentIndex={parentIndex + item.id}
          parentQuery={item.query}
          isCategorySearch={isCategorySearch}
        />
      ));

    return (
      <StyledItem>
        <StyledFilterItem>
          <CheckBox
            type="checkbox"
            value={item.name}
            onChange={this.onItemChange}
            checked={checked}
            id={id}
          />
          <ItemLabel $hasSubItems={hasSubItems} htmlFor={id}>
            {item.name || 'None'}
          </ItemLabel>
          {!hasSubItems && <Number>({item.qty})</Number>}
          {hasSubItems && (
            <ItemArrowUp
              onClick={e => {
                e.preventDefault();
                this.setState(s => ({expanded: !s.expanded}));
              }}
            />
          )}
        </StyledFilterItem>
        {renderSubItems}
      </StyledItem>
    );
  }
}
